/**
 * Ponto de entrada da aplicação UaizyChat
 * 
 * RELEASE: 2026-01-27
 * VERSION: 2.0.0 - Integração com Sentry
 * 
 * Inicializa:
 * 1. Sentry (monitoramento de erros) - ANTES de qualquer renderização
 * 2. React DOM
 */

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { initSentry } from "@/lib/sentry";
import App from "./App.tsx";
import "./index.css";
// Fontes premium para o modal de gerenciamento de acessos do KB (Sora + Manrope)
import "@fontsource/sora/400.css";
import "@fontsource/sora/600.css";
import "@fontsource/sora/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
// Roboto é usada exclusivamente no fluxo público de vistoria com linguagem Material/Flutter.
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

// Inicializa Sentry ANTES de renderizar a aplicação
// Isso garante que erros de inicialização sejam capturados
initSentry();

// HelmetProvider habilita <Helmet> nas páginas públicas da Base de Conhecimento
// para SEO (title, meta, canonical, og:*, JSON-LD).
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

